import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import { t, tr } from "../../i18n/translations";

export default function About({ onBook }) {
  const { lang } = useLang();
  return (
    <section id="about" className="bg-[#FAFAFA] py-28 sm:py-36" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5 relative">
            <div className="absolute -inset-6 lg:-inset-10 bg-[#F4F0EC] -z-10" aria-hidden="true" />
            <div className="zoom-frame aspect-[3/4]">
              <img src="https://images.pexels.com/photos/8221202/pexels-photo-8221202.jpeg" alt="Abril Suarez maquillista" />
            </div>
          </div>
          <div className="lg:col-span-7 lg:pl-8">
            <p className="overline text-[#8B6D5E] mb-4">{tr(t.about.overline, lang)}</p>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[1] mb-10">
              {tr(t.about.title, lang)}
            </h2>
            <p className="text-base sm:text-lg leading-relaxed text-[#5C5C5C] mb-6 max-w-2xl">
              {tr(t.about.body, lang)}
            </p>
            <p className="text-base leading-relaxed text-[#5C5C5C] mb-10 max-w-2xl">{tr(t.about.body2, lang)}</p>

            <div className="grid grid-cols-3 gap-6 max-w-xl border-t border-[#E8E1DA] pt-8 mb-10">
              <div>
                <p className="font-serif text-5xl text-[#1A1A1A]">10+</p>
                <p className="overline text-[#5C5C5C] mt-2">Años · Years</p>
              </div>
              <div>
                <p className="font-serif text-5xl text-[#1A1A1A]">300+</p>
                <p className="overline text-[#5C5C5C] mt-2">Novias · Brides</p>
              </div>
              <div>
                <p className="font-serif text-5xl text-[#1A1A1A]">40+</p>
                <p className="overline text-[#5C5C5C] mt-2">Editoriales</p>
              </div>
            </div>

            <button className="btn-primary" onClick={onBook} data-testid="about-book-btn">
              {tr(t.about.cta, lang)}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
